<template>
  <modal
    name="comment-declaration"
    transition="nice-modal-fade"
    :delay="100"
    height="auto"
    :draggable="false"
  >
    <div class="example-modal-content p-3 m-6 rounded">
      <div class="flex items-center justify-end w-auto">
        <button
          type="submit"
          class="mb-2 mr-0 p-0 btn-close text-xl"
          @click="hide()"
        >
          <i class="fas fa-times-circle ml-1"></i>
        </button>
      </div>
      <div
        v-if="msg_success"
        class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
        v-html="this.msg_success"
      ></div>
      <div
        v-else-if="msg_error"
        class="alert alert-danger bg-red-lighter border border-red text-sm text-red-dark px-4 py-3 rounded relative mb-4"
        v-html="this.msg_error"
      ></div>
      <h3 class="title-comment mb-5 pb-3 border-red-light border-b">
        {{ $t("requests.create_comment") }}
      </h3>

      <sp-textarea
        theme="team"
        id="comment"
        :required="true"
        v-model="comment"
        name="comment"
        :label="$t('declarations.comment_declaration')"
        :scrollable="true"
      ></sp-textarea>

      <sp-dropzone
        theme="team"
        :required="false"
        id="file_patente_id"
        :label="$t('requests.file')"
        :url="url"
        :vdropzonesuccess="CommentFileDropzoneSuccess"
        :vdropzoneError="CommentFileDropzoneError"
        tag="4"
        :vdropzone-removed-file="CommentFileDropzoneRemovedFile"
        :vdropzoneProcessing="vdropzoneProcessing"
        :maxFiles="1"
        :cinFile="response"
        :downloadFile="true"
      >
      </sp-dropzone>

      <div class="flex items-center justify-end w-auto">
        <sp-button
          theme="outline-blue"
          space="small"
          type="submit"
          class="rounded mr-0"
          @click="addComment(comment)"
          :disabled="buttonDisabled"
        >
          {{ $t("form.send") }}
          <i class="fas fa-paper-plane ml-1"></i>
        </sp-button>
      </div>
    </div>
  </modal>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import ApiService from "@/common/api.service";
import {
  SET_ApplicationMenuActive,
  SET_LabelMenuActive,
  SET_HashId,
  SET_LabelApp
} from "@/store/mutations.type";
import TextareaVue from "../../components/spKit/Textarea.vue";
import ButtonVue from "../../components/spKit/Button.vue";
import { ADD_DECLARATION_COMMENT } from "@/store/actions.type";

import DropZoneVue from "../../components/spKit/DropZone.vue";
import { API_URL } from "@/common/config";

const uploadURL = API_URL + "/documents/upload";

export default {
  components: {
    "sp-textarea": TextareaVue,
    "sp-button": ButtonVue,
    "sp-dropzone": DropZoneVue
  },
  data() {
    return {
      comment: "",
      isSubmitted: false,
      msg_success: null,
      msg_error: null,
      url: uploadURL,
      documentId: null,
      documentPath: null,
      response: {
        id: null,
        content: ""
      },
      buttonDisabled: false,
    };
  },
  mounted() {
    this.$store.commit(SET_LabelMenuActive, 1);
    this.$store.commit(SET_ApplicationMenuActive, 0);
    this.$store.commit(SET_HashId, this.session.startup_application.id);
    this.$store.commit(SET_LabelApp, this.$route.params.code_label);
  },
  methods: {
    /* Add comment request candidat */
    addComment(comment) {
      this.buttonDisabled = true;
      this.type = this.$route.params.appType;
      this.form_code = this.$route.params.formName;
      this.request_id = this.$route.params.declarationId;
      this.comment = comment;
 
       this.$store
        .dispatch(ADD_DECLARATION_COMMENT, {
          type: this.$route.params.appType,
          form_code: this.$route.params.formName,
          request_id: this.$route.params.declarationId,
          comment: this.comment,
          documentId: this.documentId
        })
        .then(data => {
          this.msg_success = data.meta.messages[0];
          this.$emit("add-comment", [comment, this.documentPath]);
          this.documentId = null;
          this.documentPath = null;
          setTimeout(
            function() {
              this.$modal.hide("comment-declaration");
              this.msg_success = null;
              this.comment = null;
              this.msg_error = null;
              this.buttonDisabled = false;
            }.bind(this),
            1500
          );
        })
        .catch(({ response }) => {
          this.msg_error = response.data.meta.messages[0];
          this.buttonDisabled = false;
        });
    },
    hide() {
      this.$modal.hide("comment-declaration");
      this.msg_success = null;
      this.comment = null;
      this.msg_error = null;
    },

    vdropzoneProcessing(file) {
      this.inProgress = true;
    },
    CommentFileDropzoneSuccess(file, response) {
      this.inProgress = false;
      this.documentPath = response.data.document.path
      this.documentId = response.data.document.id;
    },
    CommentFileDropzoneError(file, message, xhr) {
      if (xhr != undefined) {
        if (message.meta.status == 400) this.documentId = null;
      }
      this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
        "you cant upload this file";
    },
    CommentFileDropzoneRemovedFile(file, error, xhr) {
      this.documentId = null;
      this.documentPath = null;
    }
  },

  computed: {
    ...mapGetters([
      "session",
      "ApplicationMenuActive",
      "LabelMenuActive",
      "hashId",
      "LabelApplication",
      "requestForm"
    ]),
    ...mapState({
      errors: state => state.session.errors
    })
  }
};
</script>

<style scoped>
.title-comment {
  font-size: 1.125rem;
  color: #ee0049;
}

.btn-close {
  color: #ee0049;
}
</style>
